import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { unsetAuth } from "../helpers/authHelper";
import { nextAuthUrl } from "../helpers/nextApi";
import useCallApiAndLoad from "../hooks/useCallApiAndLoad";
import { logoutAction } from "../redux/features/auth";
import { AppStore } from "../redux/store";
import { logoutEndpoint } from "../services/publicService";

const useAuth = () => {
  const user = useSelector((store: AppStore) => store.auth);
  const { country } = useSelector((store: AppStore) => store.country);
  const { callEndpoint } = useCallApiAndLoad();

  const dispatch = useDispatch();

  const handleLogout = async () => {
    const { token, rft, realm } = user;

    if (realm === "customer") {
      // Sesión vía cookies httpOnly de Next: el logout server-side limpia
      // las cookies y emite BroadcastChannel para otras tabs.
      try {
        await axios.post(nextAuthUrl(country, "logout"), null, {
          withCredentials: true,
        });
      } catch (err) {
        console.warn("Next logout failed, continuing local cleanup", err);
      }
    } else if (token) {
      // Realm legacy con token en Redux/localStorage.
      await callEndpoint(logoutEndpoint(token, rft, realm));
    }

    dispatch(logoutAction({}));
    unsetAuth();
    localStorage.removeItem("nameColor");
    return window.open(`/app/${country}/auth/login`, "_self");
  };

  return {
    handleLogout,
  };
};

export default useAuth;
